let $tabla: DataTables.Api;
export default function inicializarDataTable(
    selector: string,
    columnasNoOrdenables = [],
    estadosDatatable?: { page: number; search: string; sort: string },
    cantFilas: number = 10
): void {
    setTimeout(() => {
        if ($.fn.dataTable.isDataTable(selector)) {
            $tabla.clear().destroy();
        }
        const opciones: DataTables.Settings = {
            dom: "<'d-flex justify-content-between align-items-center mb-2'fB>" +
                "t" +
                "<'d-flex justify-content-between mt-2'lip>",
            language: {
                url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json",
                paginate: {
                    first: '',
                    previous: '<i class="bi bi-chevron-left"></i>',
                    next: '<i class="bi bi-chevron-right"></i>',
                    last: ''
                }
            },
            pagingType: "simple_numbers",
            pageLength: cantFilas, // Resultados por página inicial
            responsive: true,
            ordering: true, // Permite ordenar por cada columna del datatable
            order: [], // No realiza un orden por defecto cuando se cargan los datos
            searching: true, // muestra el input de búsqueda
            destroy: true, // Permite destruir un datatable que ya tenga cargado el selector
            buttons: [ // Muestra el botón de exportar en excel (Se pueden agregar otros botones)
                {
                    extend: 'excelHtml5',
                    text: 'Exportar Excel',
                    className: 'btn btn-primary btn-sm',
                    exportOptions: {
                        columns: ':not(.no-export)'
                    }
                }
            ],
            initComplete: function () { // Se ejecuta cuando ya esta renderizado el datatable
                const searchInput = $(selector).parents('#tabla-expedientes_wrapper').find('div.dt-search input');
                searchInput.removeClass('').addClass('form-control'); // Clases al input de búsqueda
            }
        }
        if (columnasNoOrdenables.length > 0) {
            opciones.columnDefs = [];
            columnasNoOrdenables.forEach(t => {
                opciones.columnDefs.push(
                    {
                        targets: t, // indice de la columna
                        orderable: false // Para que no ordene por la columna
                    }
                )
            });
        }
        if (estadosDatatable) {
            const { page, search, sort } = estadosDatatable;
            if (page > 1) opciones.displayStart = (page - 1) * 10;
            if (search) opciones.search = { search };
            if (sort) opciones.order = [JSON.parse(sort)];
        }
        $tabla = $(selector).DataTable(opciones);
    }, 0);
}

export function obtenerTabla() {
    return $tabla;
}

export function obtenerDatos(selector: string) {
    const page = $tabla.page.info().page + 1;
    const search = $tabla.search();
    const order = $tabla.order();
    const sort = order.length > 0 ? JSON.stringify(order[0]) : "";
    return { page, search, sort }
}